import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  InvoiceError,
  InvoiceListItem,
} from '../pages/invoice/invoice-list.component';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class InvoiceService {
  private readonly url = environment.api_v2;

  constructor(private readonly http: HttpClient) {}

  public getAll(): Observable<InvoiceListItem[]> {
    return this.http.get<InvoiceListItem[]>(
      `${this.url}/v2/administrative/invoice-indication`
    );
  }

  public getErrors(invoiceId: number): Observable<InvoiceError[]> {
    return this.http
      .get<{ errors: InvoiceError[] }>(
        `${this.url}/v2/administrative/invoice-indication/${invoiceId}/logs`
      )
      .pipe(map((res) => res.errors));
  }

  public emitByIds(indicationIds: number[]): Observable<any> {
    return this.http.post(
      `${this.url}/v2/administrative/invoice-indication/emit`,
      { indicationIds }
    );
  }
}
